// src/redux/feetypeSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_feetype,
  add_feetype,
  update_feetype,
  delete_feetype,
  get_feetype_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  feetype: [],
  feetypelist:[],
  feetypefilterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};

// Async Thunks for API Calls
export const fetchfeetypeList = createAsyncThunk(
    'feetype/fetchfeetypelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_feetype_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchfeetype = createAsyncThunk(
  "feetype/fetchfeetype",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_feetype(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createfeetype = createAsyncThunk(
  "feetype/createfeetype",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_feetype(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatefeetype = createAsyncThunk(
  "feetype/updatefeetype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_feetype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletefeetype = createAsyncThunk(
  "feetype/deletefeetype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_feetype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// feetype Slice
const feetypeSlice = createSlice({
  name: 'feetypes',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name} = action.payload;
      state.formData = { id, name};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
      };
    },
    setfeetype(state, action) {
      state.feetype = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchfeetypeList.fulfilled, (state, action) => {
        state.feetypelist = action.payload.data;
      })
      .addCase(fetchfeetypeList.rejected, (state, action) => {
        state.feetypelist = [];
      })
     
       // Fetch feetype
       .addCase(fetchfeetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchfeetype.fulfilled, (state, action) => {
        state.loading = false;
        state.feetype = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchfeetype.rejected, (state, action) => {
        state.loading = false;
        state.feetype = [];
        state.error = action.payload;
      })

      // Add feetype
      .addCase(createfeetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createfeetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createfeetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update feetype
      .addCase(updatefeetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatefeetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatefeetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete feetype
      .addCase(deletefeetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletefeetype.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletefeetype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setfeetype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = feetypeSlice.actions;
export default feetypeSlice.reducer;
